import numeral from 'numeral'
import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  items: [],
  count: 0
}

const getListActions = generateActions('persons/list/GET_LIST')
const getCountActions = generateActions('persons/list/GET_COUNT')

//
const refactor = (data = []) => data.map(el => {
  const stats = el.bidsStats[0] || {}
  return ({
    _id: el._id,
	alias: el.alias,
    title: el.name,
    closeDate: stats.lastDate,
    sum: stats.bidSum ? (numeral(stats.bidSum).format('0,0') + ' ' + stats.currencySymbol) : null,
    image: el.photos.length ? el.photos[0] : null,
	miniImage: el.photos.length ? el.photos[0] : null
  })
})

export const get = createAction(
  API_CONST,
  (params = {}) => ({
    params,
    url: 'persons',
    actions: getListActions
  }),
  (params = {}) => ({ rewrite: !params.offset })
)

export const getCount = createAction(
  API_CONST,
  (params = {}) => ({
    params,
    url: 'persons/count',
    actions: getCountActions
  }),
  (params = {}) => ({ rewrite: !params.offset })
)

export default handleActions({
  [getListActions[1]]: (state, { payload, meta }) => ({
    ...state,
    items: [ ...(meta.rewrite ? [] : state.items), ...refactor(payload) ]
  }),
  [getCountActions[0]]: state => ({ ...state, count: 0 }),
  [getCountActions[1]]: (state, { payload }) => ({ ...state, count: payload.value || 0 })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/persons/list.js